export enum HSAAccountStatus {
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  PENDING_CLOSED = 'PENDING_CLOSED',
  CLOSED = 'CLOSED',
}

export interface HSACombineAccount {
  accountId: string;
  accountNumber: string;
  employeeId: string;
  personFirstName: string;
  personLastName: string;
  employerName: string;
  partnerName: string;
  ssn?: string;
  birthOn: string;
  investorAccountBalance?: number;
  accountStatus: HSAAccountStatus;
  availableBalance: number;
}

export enum CombineHSASectionType {
  FROM = 'from',
  TO = 'to',
}
